export default "__VITE_ASSET__DKpuqsKs__"